import { render, staticRenderFns } from "./dashBoardDetail.vue?vue&type=template&id=4e54d2d0&"
import script from "./dashBoardDetail.vue?vue&type=script&lang=js&"
export * from "./dashBoardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports